import type { InstallAppResponse } from '@wix/app-installer/types';
import { getPostInstallationUrlWithQuery } from './getPostInstallationUrl';

const ALLOWED_PROTOCOLS = ['https:', 'http:'];

export const usePostInstallationUrl = () => {
  const isValidUrl = (url: string): boolean => {
    try {
      const { protocol } = new URL(url);
      if (!ALLOWED_PROTOCOLS.includes(protocol)) {
        console.error('postInstallationUrl protocol is not allowed', protocol);
        return false;
      }
      return true;
    } catch (e) {
      console.error('postInstallationUrl is invalid', e);
      return false;
    }
  };

  const postInstallationUrlQuery =
    new URLSearchParams(window.location.search).get('postInstallationUrl') ||
    undefined;

  const hasPostInstallationUrl =
    !!postInstallationUrlQuery && isValidUrl(postInstallationUrlQuery);

  const redirectToPostInstallationUrlIfRequired = (
    response: InstallAppResponse,
  ) => {
    if (response.status === 'SUCCESS' && hasPostInstallationUrl) {
      const {
        tenantId: responseTenantId,
        appId,
        instanceId,
        signedInstance,
      } = response.installedApps[0];
      const postInstallationUrl = getPostInstallationUrlWithQuery({
        postInstallationUrl: postInstallationUrlQuery,
        appId,
        tenantId: responseTenantId,
        instanceId,
        signedInstance,
      });
      window.location.assign(postInstallationUrl!);
    }
  };
  return {
    hasPostInstallationUrl,
    postInstallationUrl: hasPostInstallationUrl
      ? postInstallationUrlQuery
      : undefined,
    redirectToPostInstallationUrlIfRequired,
  };
};
